import { useHistory } from 'react-router'

export const SignUp: React.FC = () => {
	//usehistory hook
	const { push } = useHistory()
	return (
		<section className='component-content'>
			<h1>Signup</h1>
			<p>
				Already have an account?
				<span>
					<b onClick={() => push('/login')}> Log In</b>
				</span>
			</p>
			<input type='text' placeholder='Full Name' />
			<input type='text' placeholder='Email' />
			<input type='password' placeholder='Password' />
			<input type='password' placeholder='Confirm Password' />
			<button>Sign Up</button>
			<p>
				By registering you agree to the
				<span>
					<b> Terms of Use</b>
				</span>
			</p>
		</section>
	)
}
